import { UsersContainerPopupInput } from './users-container-popup-input';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { NgIf } from '@angular/common';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FlexModule } from '@angular/flex-layout/flex';
import { UsersContainerComponent } from '../users-container/users-container.component';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'pcp-users-container-popup',
    templateUrl: './users-container-popup.component.html',
    styleUrls: ['./users-container-popup.component.scss'],
    imports: [NgIf, MatDialogTitle, CdkScrollable, MatDialogContent, FlexModule, UsersContainerComponent, MatDialogActions, MatButton, MatDialogClose]
})
export class UsersContainerPopupComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: UsersContainerPopupInput) {}

  ngOnInit() {}
}
